module.exports = __webpack_public_path__ + "img/dsci0133.7029f7f6.jpg";